export default __webpack_public_path__ + "static/media/A4.05f40efb.png";